(() => {
  const GLOBAL_INITIAL_SLIDE = 0; // índice base 0 → 2 = tercer slide
  const sectionRoot = document.querySelector(".redesign_testimonials_section");
  const section = (sel, root = sectionRoot) => Array.from(root?.querySelectorAll(sel) || []);

  // Reproduce todos los videos
  const playAllTestimonyVideos = () => {
    section(".redesign_testimonials_swiper_slide video").forEach((v) => {
      // Asegura autoplay en la primera carga
      if (v.muted !== true) v.muted = true;
      const p = v.play?.();
      // Maneja la promesa de reproducción
      if (p && typeof p.catch === "function") p.catch(() => {});
    });
  };

  // Pausa todos y reproduce solo el video del slide activo
  const playOnlyActive = (swiper) => {
    const { activeIndex } = swiper;
    const slides = swiper.slides;
    // Pausar todos
    section(".redesign_testimonials_swiper_slide video").forEach((v) =>
      v.pause?.()
    );

    // Reproducir el activo
    const activeSlideEl = slides?.[activeIndex];
    if (!activeSlideEl) return;
    const activeVideo = activeSlideEl.querySelector("video");
    if (activeVideo) {
      const p = activeVideo.play?.();
      if (p && typeof p.catch === "function") p.catch(() => {});
    }
  };

  // Toggle sonido del video dentro del mismo slide del botón
  const toggleSound = (btnEl) => {
    const span = btnEl.children?.[0];
    if (span) span.classList.toggle("sound_enabled");
    const container = btnEl.parentElement?.parentElement;
    if (!container) return;
    const video = container.querySelector("video");
    if (!video) return;

    video.muted = !video.muted;
    // Si se habilita sonido, intenta reproducir por si estaba pausado
    if (!video.muted) {
      const p = video.play?.();
      if (p && typeof p.catch === "function") p.catch(() => {});
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".redesign_testimonials_swiper", {
      a11y: false,
      // grabCursor: true,
      centeredSlides: true,
      // centerInsufficientSlides: true,
      spaceBetween: 17,
      initialSlide: GLOBAL_INITIAL_SLIDE,
      loopedSlides: 10,
      loop: true,
      breakpoints: {
        1023: {
          slidesPerView: 5,
          slidesPerGroup: 2,
        },
        320: {
          slidesPerView: "auto",
          slidesPerGroup: 1,
        },
      },
      on: {
        init(swiper) {
          swiper.slideToLoop(GLOBAL_INITIAL_SLIDE, 0);
        },
        click(swiper) {
          const idx = swiper.clickedSlide?.dataset?.swiperSlideIndex;
          if (idx !== undefined) {
            swiper.slideToLoop(Number(idx));
          }
        },
      },
    });

    // Botones de sonido
    section("[aria-label='Activate Sound']").forEach((btn) => {
      btn.addEventListener("click", function () {
        toggleSound(this);
      });
    });
  });
})();
